import React from 'react';
import { connect } from 'react-redux';

import { setNotdoneListSelected } from 'actions/notdoneActions';

import {
    Date,
    Time,
    Counter,
    TextLine,
    ItemsList,
    LinkTextLine,
    RadioboxCell,
} from 'components/common/tableComponents/cellTemplates';

const EventItemList = ({ handlers, item, value }) => {
    const handler = () => handlers.openModalEvent({
        id: item.id,
        value
    });

    return <LinkTextLine handler={handler} value={value} />;
};

const stateToProps = ({ table: { notdone: { selected } } }) => ({
    selected
});

const dispatchToProps = {
    setSelected: setNotdoneListSelected
};

const NotdoneRadioboxCell = connect(stateToProps, dispatchToProps)(RadioboxCell);

const RequestTableTemplates = {
    checkbox: NotdoneRadioboxCell,
    number: Counter,
    date: Date,
    time: Time,
    name: EventItemList,
    projects: ItemsList,
    people: ItemsList,
    responsible: ItemsList,
    contact: ItemsList,
    organizations: ItemsList
};

export default function getNotdoneTableTemplate(columnName) {
    return RequestTableTemplates[columnName] || TextLine;
}
